import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { inject, Injectable } from '@angular/core';
import { Dtos } from '#models';
import { environment } from '#environments';

@Injectable({
  providedIn: 'root',
})
export class KMSService {
  private http = inject(HttpClient);

  public getKMSManagementOfChangeList(item: Dtos.KMSRequestList) {
    return this.http.post<Dtos.KMSResponse>(`${environment.apiUrl}/pssr/kms/GetManagementOfChangeList/`, item);
  }

  public getKMSManagementOfChange(item: Dtos.KMSRequest): Observable<Dtos.KMSResponseItem> {
    return this.http.post<Dtos.KMSResponseItem>(`${environment.apiUrl}/pssr/kms/GetManagementOfChange/`, item);
  }
}
